const handleScroller = (id) => {
  document.getElementById(id).scrollIntoView();
};

export default handleScroller;